import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from "@angular/core";
import { RequestDevicesService } from "../../../services/request-devices.service";
import { RequestsService } from "../../../services/requests.service";
import { NewRequestDevice } from "../../../models/request/new-request/new-request-device";
import { GridComponent } from "@progress/kendo-angular-grid";
import { LookupService } from "../../../services/lookup.service";
import { forkJoin } from "rxjs";
import { KeyValueObject } from "../../../models/core/KeyValueObject";
import { DropDownFilterSettings } from "@progress/kendo-angular-dropdowns";
import { HierarchyLookupModel } from "../../../models/core/HierarchyLookupModel";
import { DeviceStatus, RequestType } from "../../../enums";
import { ReserveResult } from "../../../enums/reserve-result.enum";
import { DeviceModelDto } from "../../../models/device/device-model-dto";
import { DeviceModelsService } from "../../../services/device-models.service";
import { CustomerObjectsService } from "../../../../categories/customer-objects/customer-objects.service";
import { CustomerObjectDeviceDto } from "../../../models/customerObject/customer-object-device";
import { RequestBwt } from "../../../models/request/request-bwt";
import { data } from "jquery";
import { DeviceTypesService } from "../../../services/device-types.service";
import { DeviceTypeDto } from "../../../models/device/device-type.dto";
import { SecurityService } from "../../../../core/services/security.service";
import { NotificationService } from "../../../../core/services/notification.service";
import { NotificationType } from "../../../../core/services/notification-type";
import { SetRequestDevicesDiscount, SetRequestDevicesDiscountItem } from "../../../models/discount/set-request-devices-discount";
import { DiscountLevelsService } from "../../../services/discount-levels.service";
import { DevicesHierarchicalSelectorComponent } from "../../devices-hierarchical-selector/devices-hierarchical-selector.component";
import { DialogService } from "@progress/kendo-angular-dialog";
import { ContragentsService } from "../../../../categories/contragents/contragents.service";
import { PaymentTypeEnum } from "../../../enums/payment-type.enum";
import { RequestTypeService } from "../../../services/request-type.service";
import { DevicesService } from "../../../services/devices.service";
import { ReclamationDevicesService } from "../../../services/reclamation-devices.service";
import { AppService } from "../../../../app.service";
import { CachesService } from "../../../services/caches.service";
import { PaymentStatusEnum } from "../../../enums/payment-status.enum";
import { NewRequest } from "../../../models/request/new-request/new-request";

@Component({
    selector: 'request-page-devices',
    templateUrl: './request-page-devices.component.html',
    styleUrls: ['./request-page-devices.component.scss',
        '../../../../../vendor/libs/angular2-ladda/angular2-ladda.scss',
        '../../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
    ],
    encapsulation: ViewEncapsulation.None,
})
export class RequestPageDevicesComponent implements OnInit {

    @ViewChild("mainRequestDevicesGrid") mainRequestDevicesGrid: GridComponent;

    @Input() requestId: number;
    @Input() requestTypeId: number;
    @Input() requestCategoryId: number;
    @Input() customerContragentId: number;
    @Input() reclamationDeviceId: number;
    @Input() paymentStatusId: number;
    @Input() canEditRequest: boolean = true;

    @Output() refreshRequestEvent: EventEmitter<RequestBwt> = new EventEmitter<RequestBwt>();
    @Output() refreshRequestDeviceModelsEvent: EventEmitter<any> = new EventEmitter<any>();

    loading: boolean = false;
    dropDownFilterSettings: DropDownFilterSettings = { caseSensitive: false, operator: 'contains' };

    roleForceDiscount: boolean;
    roleDiscountLimit: number;
    maxDiscountLimit: number;

    allRequestDevices: NewRequestDevice[] = [];
    mainRequestDevices: NewRequestDevice[] = [];
    additionalRequestDevices: NewRequestDevice[] = [];
    customerObjectDevices: CustomerObjectDeviceDto[] = [];

    deviceTypeFullItems: DeviceTypeDto[] = [];
    deviceTypes: KeyValueObject[] = [];
    deviceModels: DeviceModelDto[] = [];
    dropDownDeviceModels: DeviceModelDto[] = [];
    deviceSuppliers: DeviceModelDto[] = [];
    dropDownDeviceSuppliers: DeviceModelDto[] = [];
    marketPlaces: KeyValueObject[] = [];
    warrantyRequestTypes: number[] = [];
    installTypes: KeyValueObject[] = [];
    costCenters: KeyValueObject[] = [];

    contragentPaymentTypeId: number;

    constructor(
        private appService: AppService,
        private deviceTypesService: DeviceTypesService,
        private lookupService: LookupService,
        private requestsService: RequestsService,
        public deviceModelsService: DeviceModelsService,
        private requestDevicesService: RequestDevicesService,
        private customerObjectsService: CustomerObjectsService,
        private securityService: SecurityService,
        private notificationService: NotificationService,
        private discountLevelsService: DiscountLevelsService,
        private dialogService: DialogService,
        private contragentsService: ContragentsService,
        private requestTypesService: RequestTypeService,
        private devicesService: DevicesService,
        private reclamationDevicesService: ReclamationDevicesService,
        private cachesService: CachesService
    ) { }

    ngOnInit(): void {
        this.roleDiscountLimit = this.securityService.currentUser.discountLimit;
        this.roleForceDiscount = this.securityService.currentUser.forceDiscount;

        this.loadRequestDevices();

        const deviceTypes$ = this.deviceTypesService.getAllDeviceTypesNoCategory();
        const deviceModels$ = this.deviceModelsService.getAll();
        const marketPlaces$ = this.lookupService.getData('device-market-places', null);
        const contragent$ = this.contragentsService.getContragentWithContact(this.customerContragentId);
        const warrantyRequestTypes$ = this.requestTypesService.getWarrantyRequestTypes();
        const installTypes$ = this.lookupService.getData('device-install-types', null);
        const costCenters$ = this.lookupService.getData('cost-centers', null);

        forkJoin(deviceTypes$, deviceModels$, marketPlaces$, contragent$, warrantyRequestTypes$, installTypes$, costCenters$)
            .subscribe(([deviceTypes, deviceModels, marketPlaces, contragent, warrantyRequestTypes, installTypes, costCenters]) => {
                this.deviceTypeFullItems = deviceTypes;
                this.deviceTypes = deviceTypes.map(x => new KeyValueObject(x.deviceTypeId, x.name));
                this.deviceModels = deviceModels;
                this.dropDownDeviceModels = this.deviceModels;
                this.deviceSuppliers = this.deviceModels.filter(x => x.parentId == null);
                this.dropDownDeviceSuppliers = this.deviceSuppliers;
                this.marketPlaces = marketPlaces;
                this.warrantyRequestTypes = warrantyRequestTypes;
                this.installTypes = installTypes;
                this.costCenters = costCenters;

                if (contragent) {
                    this.contragentPaymentTypeId = contragent.paymentTypeId;
                }
            });
    }

    loadRequestDevices() {
        this.loading = true;

        if (this.isReclamation || this.isService) {
            const requestDevices$ = this.requestsService.getRequestDevices(this.requestId);
            const requestCustomerObjectDevices$ = this.customerObjectsService.getRequestCustomerObjectDevices(this.requestId);

            forkJoin(requestDevices$, requestCustomerObjectDevices$)
                .subscribe(([requestDevices, requestCustomerObjectDevices]) => {
                    requestDevices.forEach(x => x.discountPrimary = x.discount);
                    this.allRequestDevices = requestDevices;
                    this.mainRequestDevices = requestDevices.filter(x => x.manuallyAdded == false && !x.inClaim);
                    this.mainRequestDevices = this.groupDevices(this.mainRequestDevices);
                    this.additionalRequestDevices = requestDevices.filter(x => x.manuallyAdded == true);
                    this.additionalRequestDevices = this.groupDevices(this.additionalRequestDevices);
                    this.customerObjectDevices = requestCustomerObjectDevices;
                    this.customerObjectDevices.forEach(x => {
                        x.manufactureDate = this.appService.parseDate(x.manufactureDate);
                        x.lastRequestDate = this.appService.parseDate(x.lastRequestDate);
                    });
                    this.refreshRequestDeviceModelsEvent.emit();
                    this.loading = false;
                }, () => this.loading = false);
        }
        else {
            this.requestsService.getRequestDevices(this.requestId).subscribe((data) => {
                data.forEach(x => x.discountPrimary = x.discount);
                this.allRequestDevices = data;
                this.mainRequestDevices = data.filter(x => x.manuallyAdded == false);
                this.mainRequestDevices = this.groupDevices(this.mainRequestDevices);
                this.additionalRequestDevices = data.filter(x => x.manuallyAdded == true);
                this.additionalRequestDevices = this.groupDevices(this.additionalRequestDevices);
                this.loading = false;
            }, () => this.loading = false);
        }
    }

    groupDevices = (devices: NewRequestDevice[]) => {
        return Object.values(
            devices.reduce((acc, item) => {
                const key = this.getGroupKey(item);
                if (!acc[key]) acc[key] = { ...item, requestDeviceIds: [], quantity: 0 }
                acc[key].requestDeviceIds.push(item.requestDeviceId);
                acc[key].quantity += item.quantity;
                return acc;
            }, {} as NewRequestDevice));
    }

    getGroupKey = (item: NewRequestDevice) => `${item.deviceModelId}-${item.availableInCentralWarehouses}-${item.reserveResultId}-${item.isCompletelyAvailable}`

    getNameById(items: KeyValueObject[] = [], id: number): string {
        return items.some(x => x.id == id)
            ? items.find(x => x.id == id).name
            : '';
    }

    createNewMainRequestDevice(isCustomerDevice: boolean = false, isFromClientButton: boolean = false): NewRequestDevice {
        let requestDevice = new NewRequestDevice;
        requestDevice.requestId = this.requestId;
        requestDevice.manuallyAdded = false;
        requestDevice.customerDevice = isCustomerDevice;
        requestDevice.isFromClientButton = isFromClientButton;
        requestDevice.cost = 0;
        requestDevice.fullCost = 0;
        requestDevice.requestDeviceId = 0;

        if (this.isReclamation) {
            requestDevice.reserveResultId = <number>ReserveResult.installedOnTsp;
            requestDevice.inClaim = true;
        }
        else {
            requestDevice.reserveResultId = <number>ReserveResult.notBooked;
        }

        this.maxDiscountLimit = 0;

        return requestDevice;
    }

    addNewMainRequestDevice(isReclamation: boolean = false, customerDevice: boolean = false, inClaim: boolean = false) {
        const dialogRef = this.dialogService.open({
            content: DevicesHierarchicalSelectorComponent,
            title: 'Добавление оборудования',
            width: '80%',
            height: '870px',
            minWidth: '800px'
        });
        const devicesSelector = <DevicesHierarchicalSelectorComponent>dialogRef.content.instance;

        devicesSelector.height = 500;
        devicesSelector.defaultRequestCategoryId = this.requestCategoryId;
        devicesSelector.disableFreeItems = !this.isWarrantyRequest;
        devicesSelector.requestId = this.requestId;
        devicesSelector.isReclamation = isReclamation;

        devicesSelector.onCancel.subscribe(() => {
            dialogRef.close();
        });
        devicesSelector.onContinue.subscribe((requestDevices: NewRequestDevice[]) => {
            this.maxDiscountLimit = 0;
            dialogRef.close();

            this.loading = true;
            requestDevices.forEach(requestDevice => {
                requestDevice.requestId = this.requestId;
                requestDevice.manuallyAdded = false;
                requestDevice.inClaim = inClaim;
                requestDevice.customerDevice = customerDevice;
                requestDevice.reserveResultId = <number>ReserveResult.notBooked;
            });

            const result: NewRequestDevice[] = [];
            for (const requestDevice of requestDevices) {
                for (let i = 0; i < requestDevice.quantity; i++) {
                    result.push({ ...requestDevice, quantity: 1 });
                }
            }

            this.createMainRequestDevicesMultiple(result);
        });
    }

    addNewMainCustomerRequestDevice() {
        if (this.isReclamation) {
            this.addNewMainRequestDevice(true, true, true);
        }
        else {
            this.mainRequestDevicesGrid.addRow(this.createNewMainRequestDevice(true, true));
        }
    }

    createMainRequestDevicesMultiple(requestDevices: NewRequestDevice[] = []) {
        if (requestDevices.length == 0) {
            this.loading = false;
            return;
        }

        this.loading = true;
        const createRequestDevices$ = requestDevices.map(requestDevice => {
            return this.requestDevicesService.create(requestDevice);
        });

        forkJoin(createRequestDevices$).subscribe(() => {
            this.loadRequestDevices();
        });
    }

    saveMainRequestDeviceHandler({ dataItem }: any) {
        this.loading = true;
        let isNew = dataItem.requestDeviceId == null || dataItem.requestDeviceId == 0 || dataItem.requestDeviceIds.length == 0;

        if ((isNew && dataItem.customerDevice == true) ||
            (!isNew && dataItem.customerDevice == true && dataItem.reserveResultId == <number>ReserveResult.notBooked)) {
            dataItem.reserveResultId = <number>ReserveResult.equipmentPurchasedByEngineer;
        }
        else if ((isNew && dataItem.customerDevice != true) ||
            (!isNew && dataItem.customerDevice != true && dataItem.reserveResultId == <number>ReserveResult.equipmentPurchasedByEngineer)) {
            dataItem.reserveResultId = <number>ReserveResult.notBooked;
        }

        if (dataItem.reserveResultId == null) {
            dataItem.reserveResultId = <number>ReserveResult.notBooked;
        }

        dataItem.quantity = dataItem.quantity == null ? 1 : dataItem.quantity;

        let requestDeviceIds = dataItem.requestDeviceIds.filter(x => x != 0 && x != null);
        const requests$ = [];

        if (dataItem.quantity < requestDeviceIds.length) {
            const removeCount = requestDeviceIds.length - dataItem.quantity;
            const idsToRemove = requestDeviceIds.sort((a, b) => b - a).slice(0, removeCount);
            requestDeviceIds = requestDeviceIds.filter(x => !idsToRemove.includes(x))
            const removes$ = idsToRemove.map(requestDeviceId =>
                this.requestDevicesService.remove(requestDeviceId.toString(), null, null, true));
            requests$.push(...removes$);
        }

        if (dataItem.quantity > requestDeviceIds.length) {
            const createCount = dataItem.quantity - requestDeviceIds.length;
            const creates$ = Array.from({ length: createCount }, (_, i) => i).map(_ =>
                this.requestDevicesService.create({
                    ...dataItem,
                    requestId: this.requestId,
                    requestDeviceId: 0
                }, null));
            requests$.push(...creates$);
        }

        if (requestDeviceIds.length > 0) {
            const updates$ = requestDeviceIds.map(requestDeviceId =>
                this.requestDevicesService.update({
                    ...dataItem,
                    requestDeviceId: requestDeviceId
                }, null));
            requests$.push(...updates$);
        }

        forkJoin(requests$).subscribe(() => {
            this.loadRequestDevices();
        });
    }

    removeMainRequestDeviceHandler({ dataItem }: any) {
        this.loading = true;
        const requestDeviceIds = dataItem.requestDeviceIds.filter(x => x != 0 && x != null);
        const removes$ = requestDeviceIds.map(requestDeviceId =>
            this.requestDevicesService.remove(requestDeviceId.toString(), null, null, true));
        forkJoin(removes$).subscribe(() => {
            this.loadRequestDevices();
            this.refreshRequest();
            this.refreshDeviceDropdowns();
        });
    }

    changeMainRequestCustomerDevice(event: any, requestDevice: NewRequestDevice) {
        if (event.target.checked) {
            requestDevice.costCenterId = null;
            requestDevice.costCenterName = null;
        }
    }

    public deviceTypeChange(deviceTypeId: number, requestDevice: NewRequestDevice | CustomerObjectDeviceDto = null) {
        if (requestDevice) {
            requestDevice.deviceModelId = null;
            requestDevice.deviceSupplierId = null;
        }

        this.calculateMaxDiscountLimit(requestDevice);
    }

    public deviceSupplierChange(supplierId: number, requestDevice: NewRequestDevice | CustomerObjectDeviceDto = null) {
        if (requestDevice) {
            requestDevice.deviceModelId = null;
        }
    }

    public cellClickRequestDeviceHandler({ sender, rowIndex, dataItem, columnIndex }) {
        if (columnIndex < 11) {
            this.editRequestDeviceHandler({ sender, rowIndex, dataItem });
        }
    }

    public editRequestDeviceHandler({ sender, rowIndex, dataItem }) {
        this.handleDeviceSuppliersDropdownOpen(dataItem.deviceTypeId);
        this.handleDeviceModelsDropdownOpen(dataItem.deviceSupplierId);
        this.calculateMaxDiscountLimit(dataItem);

        if (dataItem.manufactureDate) {
            dataItem.manufactureDate = new Date(dataItem.manufactureDate);
        }

        sender.editRow(rowIndex);
    }

    public handleDeviceSuppliersDropdownOpen(deviceTypeId: number) {
        this.dropDownDeviceSuppliers = this.deviceModels != null && deviceTypeId
            ? this.deviceSuppliers.filter(x => x.typeId == deviceTypeId)
            : [];
    }

    public handleDeviceModelsDropdownOpen(deviceSupplierId: number) {
        this.dropDownDeviceModels = this.deviceModels != null && deviceSupplierId
            ? this.deviceModels.filter(x => x.parentId === deviceSupplierId)
            : [];
    }

    public checkCustomerObjectReclamationDevice(event: any, dataItem: CustomerObjectDeviceDto) {
        this.loading = true;
        if (event.target.checked) {
            if (this.reclamationDeviceId == null) {
                this.requestDevicesService.createFromDevice(this.requestId, dataItem.deviceId).subscribe((resp) => {
                    this.reclamationDeviceId = resp.data.reclamationDeviceId;
                    this.reclamationDevicesService.updateReclamationRequestDevice(this.requestId, resp.data.reclamationDeviceId).subscribe(() => {
                        this.loadRequestDevices();
                        this.refreshRequest();
                    });
                });
            } else {
                this.notificationService.confirmation({
                    title: 'В заявке уже указано оборудование в рекламации. Заменить?',
                    confirmButtonText: "Заменить",
                    cancelButtonText: "Нет"
                }, () => {
                    this.requestDevicesService.createFromDevice(this.requestId, dataItem.deviceId).subscribe((resp) => {
                        this.reclamationDeviceId = resp.data.reclamationDeviceId;
                        this.reclamationDevicesService.updateReclamationRequestDevice(this.requestId, resp.data.reclamationDeviceId).subscribe(() => {
                            this.loadRequestDevices();
                            this.refreshRequest();
                        });
                    });
                }, () => {
                    this.loadRequestDevices();
                    this.refreshRequest();
                });
            }
        }
        else {
            this.reclamationDeviceId = null;
            this.requestDevicesService.deleteFromDevice(this.requestId, dataItem.deviceId).subscribe(() => {
                this.loadRequestDevices();
                this.refreshRequest();
            });
        }
    }

    public checkCustomerObjectServiceDevice(event: any, dataItem: CustomerObjectDeviceDto) {
        this.loading = true;
        if (event.target.checked) {
            this.requestDevicesService.createFromDevice(this.requestId, dataItem.deviceId).subscribe(() => {
                this.loadRequestDevices();
                this.refreshRequest();
            }, () => {
                dataItem.existInRequestDevices = false;
                this.loading = false;
            });
        }
        else {
            this.requestDevicesService.deleteFromDevice(this.requestId, dataItem.deviceId).subscribe(() => {
                this.loadRequestDevices();
                this.refreshRequest();
            }, () => {
                dataItem.existInRequestDevices = true;
                this.loading = false;
            });
        }
    }

    refreshRequest() {
        this.requestsService.getBwtById(this.requestId).subscribe(resp => {
            this.refreshRequestEvent.emit(resp.entity);
        });
    }

    requestDeviceNotReserved(dataItem: NewRequestDevice): boolean {
        return dataItem == null || dataItem.deviceStatusId != DeviceStatus.reserved;
    }

    public canSaveRequestDevice(requestDevice: NewRequestDevice): boolean {
        const discountValid = !this.discountInvalid(requestDevice);
        const costCenterValid = requestDevice.costCenterId != null || requestDevice.customerDevice;

        return (requestDevice.deviceTypeId != null &&
            requestDevice.deviceSupplierId != null &&
            requestDevice.deviceModelId != null &&
            costCenterValid &&
            discountValid) ||
            !this.isReclamation && (requestDevice.customerDevice == true &&
                discountValid)
            ||
            this.isReclamation && requestDevice.deviceTypeId != null &&
            requestDevice.deviceSupplierId != null &&
            requestDevice.deviceModelId != null &&
            discountValid &&
            requestDevice.quantity >= 1;
    }

    public canSaveCustomerObjectDevice(device: CustomerObjectDeviceDto): boolean {
        return device.deviceTypeId != null && device.deviceSupplierId != null && device.deviceModelId != null;
    }

    public rowClass() {
        return {
            'cursor-pointer': true
        };
    }

    getDeviceSum(requestDevice: NewRequestDevice): number {
        return requestDevice.quantity * this.getCostWithDiscount(requestDevice);
    }

    changeDiscountLevel(rate: number) {
        if (rate != null) {
            this.mainRequestDevices.map(x => {
                let maxDiscount = this.calculateMaxDiscountLimit(x, true);
                x.discount = maxDiscount * rate;
            });
        }
        else {
            this.mainRequestDevices.forEach(x => x.discount = x.discountPrimary);
        }
    }

    commitDiscountLevel(rate: number) {
        let requestDeviceItems: SetRequestDevicesDiscountItem[] = [];

        this.mainRequestDevices.forEach(requestDevice => {
            requestDevice.requestDeviceIds.forEach(requestDeviceId => {
                let item = {
                    requestDeviceId: requestDeviceId,
                    discount: Math.floor(requestDevice.discount)
                } as SetRequestDevicesDiscountItem;
                requestDeviceItems.push(item);
            });
        });

        let setDiscountModel = {
            requestDevices: requestDeviceItems
        } as SetRequestDevicesDiscount;

        this.loading = true;
        this.discountLevelsService.setRequestDevicesDiscount(setDiscountModel).subscribe(() => {
            this.loadRequestDevices();
        });
    }

    calculateMaxDiscountLimit(requestDevice: NewRequestDevice | CustomerObjectDeviceDto, forDiscountLevel: boolean = false): number {
        if (this.roleForceDiscount) {
            if (forDiscountLevel) {
                this.maxDiscountLimit = this.deviceTypeFullItems.find(x => x.deviceTypeId == requestDevice.deviceTypeId).discountLimit;
            }
            else {
                this.maxDiscountLimit = 100;
            }
        }
        else if (requestDevice.deviceTypeId != null) {
            let deviceTypeDiscountLimit = this.deviceTypeFullItems.find(x => x.deviceTypeId == requestDevice.deviceTypeId).discountLimit;
            this.maxDiscountLimit = this.roleDiscountLimit > deviceTypeDiscountLimit
                ? deviceTypeDiscountLimit
                : this.roleDiscountLimit;
        }
        else {
            this.maxDiscountLimit = 0;
        }

        return this.maxDiscountLimit;
    }

    getCostWithDiscount(requestDevice: NewRequestDevice): number {
        if (requestDevice.fullCost && requestDevice.discount) {
            let cost = requestDevice.fullCost - (requestDevice.fullCost * requestDevice.discount / 100);
            return Number.isInteger(cost) ? cost : Math.floor(cost); // : parseFloat(cost.toFixed(2));
        }

        return requestDevice.fullCost;
    }

    discountChange(dataItem: NewRequestDevice) {
        if (this.discountInvalid(dataItem) && dataItem.discount > 0) {
            this.notificationService.error({
                title: `Вы превысили максимальный размер скидки - ${this.maxDiscountLimit}%`,
                notificationType: NotificationType.Toast,
                message: ''
            });
        }
    }

    discountInvalid(requestDevice: NewRequestDevice): boolean {
        return requestDevice.discount != null &&
            (requestDevice.discount < 0 ||
                requestDevice.discount > 100 ||
                requestDevice.discount > this.maxDiscountLimit);
    }

    getAvailableInCentralWarehouses(requestDevice: NewRequestDevice): boolean {
        return requestDevice.availableInCentralWarehouses;
    }

    getIsCompletelyAvailable(requestDevice: NewRequestDevice): boolean | null {
        return requestDevice.isCompletelyAvailable;
    }

    editCustomerObjectDevice(): CustomerObjectDeviceDto {
        return new CustomerObjectDeviceDto();
    }

    saveCustomerObjectDevice({ dataItem }) {
        this.loading = true;
        this.devicesService.update(dataItem, null, true, true).subscribe(() => {
            this.customerObjectsService.getRequestCustomerObjectDevices(this.requestId).subscribe((resp) => {
                this.customerObjectDevices = resp;
                this.customerObjectDevices.forEach(x => x.manufactureDate = this.appService.parseDate(x.manufactureDate));
                this.loading = false;
            }, () => { this.loading = false; })
        })
    }

    refreshDeviceDropdowns() {
        this.dropDownDeviceModels = this.deviceModels;
        this.dropDownDeviceSuppliers = this.deviceSuppliers;
    }

    refreshDevicesStatus() {
        this.loading = true;
        this.cachesService.refreshRequestEngineerCache(this.requestId).subscribe(() => {
            this.loadRequestDevices();
        });
    }

    get isReclamation(): boolean {
        return this.requestTypeId == <number>RequestType.reclamation;
    }

    get isService(): boolean {
        return this.requestTypeId == <number>RequestType.service;
    }

    get isWarrantyRequest(): boolean {
        return this.warrantyRequestTypes.some(x => x == this.requestTypeId);
    }

    get hasDiscountRight(): boolean {
        return this.securityService.hasClaim('role-Discounting-right');
    }

    get addDevicesDisabled(): boolean {
        return (this.paymentStatusId != null && this.paymentStatusId != <number>PaymentStatusEnum.waitIssueInvoice)
            || this.loading;
    }

    get totalPrice(): number {
        const sumOnlyInstalled = this.additionalRequestDevices.some(x => x.reserveResultId == <number>ReserveResult.installedOnTsp) ||
            this.mainRequestDevices.some(x => x.reserveResultId == <number>ReserveResult.installedOnTsp);

        let mainRequestDevicesFiltered = sumOnlyInstalled
            ? this.mainRequestDevices.filter(x => x.reserveResultId == <number>ReserveResult.installedOnTsp)
            : this.mainRequestDevices;

        let additionalRequestDevicesFiltered = sumOnlyInstalled
            ? this.additionalRequestDevices.filter(x => x.reserveResultId == <number>ReserveResult.installedOnTsp)
            : this.additionalRequestDevices;

        const mainTotalPrice = mainRequestDevicesFiltered.reduce((sum, item) => sum + (this.getCostWithDiscount(item) * item.quantity), 0);
        const additionalTotalPrice = additionalRequestDevicesFiltered.reduce((sum, item) => sum + (this.getCostWithDiscount(item) * item.quantity), 0);

        return Math.floor(mainTotalPrice + additionalTotalPrice);
    }
}